const UserRoles = {
    Agent: 'Agent',
    'G&A': 'G&A',
    WFM: 'WFM',
    Admin: 'Admin',
    Owner: 'Owner'
}

export default UserRoles;